import { useRef } from "react";

export default function useSound() {
    const audioRef = useRef(null);

    function stopSound() {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current = null;
        }
    }

    async function play(soundFile, volume = 1) {
        stopSound();

        const audio = new Audio(soundFile);
        audio.volume = volume;
        audio.loop = false;

        audioRef.current = audio;

        try {
            await audio.play();
        } catch (error) {
            console.warn("Unable to play sound:", error);
        }
    }

    async function playRandom(soundFile, volume = 1) {
        if (!soundFile || soundFile.length === 0) return;

        const randomSound = soundFile[Math.floor(Math.random() * soundFile.length)];

        await play(randomSound, volume);
    }

    return {
        play,
        playRandom,
        stopSound
    };
}